var React = require('react');

function DropRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0V0z","fill":"none","key":0}),React.createElement("path",{"d":"M11.71 15.29l2.59-2.59c.39-.39.39-1.02 0-1.41L11.71 8.7c-.63-.62-1.71-.18-1.71.71v5.17c0 .9 1.08 1.34 1.71.71z","key":1})]);
}

DropRight.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = DropRight;

DropRight.default = DropRight;
